import { gql } from "@apollo/client";

export const GET_FRECUENCIA_PLAN = gql`
query GetFrecuenciaPlan($idPlanCuidado: Int!, $idTipoProfesional: Int!, $idFiguraProfesional: Int!) {
    frecuenciaPlan(idPlanCuidado: $idPlanCuidado, idTipoProfesional: $idTipoProfesional, idFiguraProfesional: $idFiguraProfesional) {
            idFrecuenciaProfesional
            descripccion
            descripcionpp
            frecuencia
            guardia
            activo
      }
}`;

export const adaptFrecuenciaPlan = (frecuencia) => {
  return {
    idFrecuenciaPlan: frecuencia.idFrecuenciaProfesional,
    descripcion: frecuencia.descripccion,
    descripcionApp: frecuencia.descripcionapp,
    frecuencia: frecuencia.frecuencia,
    activo: frecuencia.activo,
    guardia: frecuencia.guardia
  };
};

export default adaptFrecuenciaPlan;